import { api } from '../lib/api';

/** GET /v1/device/codes/:userCode */
export interface DeviceCodeDetails {
  label: string;
  alreadyHandled: boolean;
}

export function fetchDeviceCode(userCode: string): Promise<DeviceCodeDetails> {
  return api<DeviceCodeDetails>(`/v1/device/codes/${encodeURIComponent(userCode)}`);
}

export function decideDeviceCode(
  userCode: string,
  decision: 'approve' | 'deny',
): Promise<{ ok: boolean; decision: string }> {
  return api(`/v1/device/codes/${encodeURIComponent(userCode)}/decision`, {
    method: 'POST',
    body: { decision },
  });
}

/** POST /v1/device/handoff, for a browser that is already signed in. */
export function startDesktopHandoff(label: string): Promise<{ deviceCode: string; expiresInSec: number }> {
  return api('/v1/device/handoff', { method: 'POST', body: { label } });
}
